import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      value: null
    };
  },
  methods: {
    openTransactionDetail() {
      this.params.context.componentParent.openTransactionDetail(
        this.params.data.id
      );
    }
  },
  template: `
        <span class="no-underline hover:underline cursor-pointer" v-on:click="openTransactionDetail">
            {{this.params.value}}
        </span>
    `
});
